export default __webpack_public_path__ + "static/media/logo.a7173b0a.png";